import { INotificationSettings } from './types';
import { ENotificationPeriod } from '../../../types/rest/IRestNotificationSettings';

export const getNotificationSettingsInitial =
    (): INotificationSettings => {
        const NOTIFICATION_INITIAL: INotificationSettings = {
            enabled: false,
            notificationEmail: '',
            period: ENotificationPeriod.SOON,
            scope: []
        }
        return NOTIFICATION_INITIAL;
    };
